import React, { Component } from 'react';
// import circulair from '../downloads/Circulaire et arrete USI.pdf';
export default class Home extends Component{

  render(){
    return(
      <div className="row section">
        <div className="col-sm-12">
          <div className="section panel">
            <h2>Pr&eacute;sentation de l’USI</h2>

            <p>L’Unit&eacute; de Syst&egrave;me d’information du MENFP (USI-MENFP) est une structure technique, directement rattach&eacute;e &agrave; la Direction G&eacute;n&eacute;rale du Minist&egrave;re de l’&eacute;ducation Nationale et de la Formation Professionnelle, cr&eacute;&eacute;e par d&eacute;cision minist&eacute;rielle en date du 22 Janvier 2016.</p>
            <p>La coordination de l’USI-MENFP est confi&eacute;e &agrave; un cadre choisi parmi les hauts fonctionnaires de cat&eacute;gorie A du Minist&egrave;re ayant au moins 10 ann&eacute;es de service.  Il porte le titre de Coordonnateur ayant rang de Directeur.</p>
            <p>L’USI-MENFP a pour mission de faire connaître et de promouvoir les bonnes pratiques en mati&egrave;re de management des syst&egrave;mes d’information. Elle est donc responsable de la production, de la maintenance et du d&eacute;veloppement du syst&egrave;me d’information.</p>
            <p>Le syst&egrave;me d’information  comprend des applications m&eacute;tier, des infrastructures techniques (mat&eacute;riels, r&eacute;seau, s&eacute;curit&eacute;, syst&egrave;me d’exploitation  et base de donn&eacute;es), ainsi que les diff&eacute;rents outils du centre d’assistance.</p>
            <p>Outre les fonctions administratives, les m&eacute;tiers de l’USI sont l’exploitation, la maîtrise d’œuvre, la maîtrise d’ouvrage et <span data-toggle="tooltip" className="usi_tooltip" title="L'Assistant &agrave; Ma&iuml;trise d'Ouvrage (AMO ou AMOA) a pour mission d'aider le ma&iuml;tre d'ouvrage &agrave; d&eacute;finir, piloter et exploiter, le projet. L'assistant a un r&ocirc;le de conseil et/ou d'assistance, et de proposition, le d&eacute;cideur restant le ma&iuml;tre d'ouvrage. Il facilitie la coordination de projet et permet au ma&iuml;tre d'ouvrage de remplir plainement ses obligation aut titre de la gestion du projet een r&eacute;alisant une mission d'assistance &agrave; ma&iuml;trise d'ouvrage.">l’AMO</span> , le conseil, la conduite du changement et de projet, l’innovation et la veille technologique.</p>
            <p>L’USI-MENFP a pour objectifs de:</p>

            <ul>
              <li>Favoriser l’optimisation des &eacute;changes de donn&eacute;es.</li>
              <li>Assurer la veille scientifique des avanc&eacute;es technologiques.</li>
              <li>Assurer la veille scientifique des avanc&eacute;es technologiques.</li>
              <li>Proposer, impl&eacute;menter et &eacute;valuer la performance des processus et des proc&eacute;dures visant &agrave; am&eacute;liorer le fonctionnement des diff&eacute;rents services du syst&egrave;me.</li>
            </ul>

            <p>La strat&eacute;gie de l’Unit&eacute; de Syst&egrave;me d'Information passe par deux points essentiels :</p>

            <ul>
              <li>Promotion  des bonnes pratiques pour passer d’une approche manuelle et fragment&eacute;e &agrave; un processus automatis&eacute; avec des rapports complets devant faciliter la prise de d&eacute;cision. </li>
              <li>Fiabilisation des informations disponibles et une r&eacute;&eacute;valuation des m&eacute;canismes de collecte tenant compte de l'archivage  des donn&eacute;es.</li>
            </ul>

            <p>L’USI-MENFP  est au service de toutes les structures du MENFP ainsi que les enseignants, les &eacute;coles, les &eacute;l&egrave;ves, les administratifs et les partenaires. D’autres responsabilit&eacute;s incombent &agrave; l’USI telles que: les supports &agrave; un ensemble de services adapt&eacute;s, la conception et la cr&eacute;ation &agrave; la demande de solutions informatiques complexes et innovants pour l’enseignement, l’articulation du syst&egrave;me d’information avec les besoins.</p>
            <p>L’effectif actuel de l’USI est de 15 personnes et le Syst&egrave;me d’Information du MENFP dans son ensemble compte environ 50 &agrave; 60 « informaticiens » distribu&eacute;s dans les diff&eacute;rentes structures.</p>
          </div>

          {/*
            <div id="usiPopup" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="usiPopup" style={ tooltipStyle } aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="usiPopup">Definition</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    oijsadf
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>
          */}


        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/Home.js